// extracted by mini-css-extract-plugin
export var blocked = "buildmodal-module--blocked--2ktJ1";
export var ___gatsby = "buildmodal-module--___gatsby--38-km";
export var loader = "buildmodal-module--loader--n2DqL";
export var overlay = "buildmodal-module--overlay--lT0kp";
export var modal = "buildmodal-module--modal--14FQn";